
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { COLORS } from '../config/constants.js';
import TerviLogo from '../components/common/TerviLogo.jsx';
import { Download, Smartphone, X, Share, CheckCircle2, Users, Search, MessageSquare, Star } from 'lucide-react';
import PublicFooter from '../components/common/PublicFooter.jsx';
import clienteBg from '../assets/cliente.png';
import trabalhoBg from '../assets/trabalho.png';
import trabalho2Bg from '../assets/trabalho2.png';
import trabalho3Bg from '../assets/trabalho3.png';
import trabalho4Bg from '../assets/trabalho4.png';

const WelcomeScreen = () => {
    const [activeSlide, setActiveSlide] = useState(0);
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [showGuide, setShowGuide] = useState(false);
    const navigate = useNavigate();

    const welcomeContent = [
        { text: "Conectando suas necessidades aos melhores profissionais da sua região.", image: trabalhoBg },
        { text: "Encontre serviços de confiança com avaliações reais.", image: trabalho2Bg },
        { text: "Aumente sua visibilidade e conquiste mais clientes.", image: trabalho3Bg },
        { text: "Um passo de coragem para novas oportunidades.", image: trabalho4Bg }
    ];

    useEffect(() => {
        const slideTimer = setInterval(() => {
            setActiveSlide(prev => (prev + 1) % welcomeContent.length);
        }, 4000);

        // MOSTRA O POPUP APÓS 3 SEGUNDOS
        const popupTimer = setTimeout(() => {
            setShowPopup(true);
        }, 3000);

        const handler = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
        };
        window.addEventListener('beforeinstallprompt', handler);

        return () => {
            clearInterval(slideTimer);
            clearTimeout(popupTimer);
            window.removeEventListener('beforeinstallprompt', handler);
        };
    }, [welcomeContent.length]);

    const handleInstallAction = async () => {
        setShowPopup(false);
        if (deferredPrompt) {
            deferredPrompt.prompt();
            const { outcome } = await deferredPrompt.userChoice;
            if (outcome === 'accepted') setDeferredPrompt(null);
        } else {
            setShowGuide(true);
        }
    };

    return (
        <div className="flex flex-col items-center h-full w-full bg-gray-100 overflow-y-auto relative text-left">

            <div className="absolute top-4 right-4 z-20">
                <span className="text-[10px] font-black text-gray-900 uppercase tracking-[0.2em] opacity-60">Fase Beta</span>
            </div>

            <div className="w-full relative pt-12 pb-4 mb-4 flex-shrink-0">
                <div className="text-center relative z-10 flex flex-col items-center px-4">
                    <TerviLogo size={56} />
                    <p className="text-[11px] font-bold uppercase tracking-[0.2em] mt-2 text-gray-600">Autônomos e Especializados</p>
                </div>
            </div>

            <div className="w-full px-4 flex-shrink-0">
                 <div className="relative h-40 flex flex-col items-center justify-center rounded-xl overflow-hidden shadow-lg mb-4">
                    <img src={welcomeContent[activeSlide].image} alt="Bem-vindo" className="absolute inset-0 w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-black/40"></div>
                    <div className="relative z-10 text-center p-6">
                        <h2 className="text-xl text-white leading-tight font-medium">
                            Bem-vindo ao <span className="font-bold">T-SERVI</span>!
                        </h2>
                        <p className="text-xs text-white mt-2 font-semibold shadow-sm">{welcomeContent[activeSlide].text}</p>
                    </div>
                    <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-2">
                        {welcomeContent.map((_, index) => (
                            <button key={index} onClick={() => setActiveSlide(index)} className={`h-1.5 rounded-full transition-all duration-300 ${activeSlide === index ? 'w-6 bg-white' : 'w-1.5 bg-white/40'}`}></button>
                        ))}
                    </div>
                </div>
            </div>

            <div className="w-full px-4 space-y-6 flex-shrink-0">
                <div className="pt-2">
                    <div className="flex justify-between items-start space-x-3 text-center mb-6">
                        <div className="w-1/2">
                            <button onClick={() => navigate('/login')} className="w-full py-4 text-sm rounded-2xl font-black uppercase tracking-widest transition transform active:scale-95 shadow-xl shadow-blue-100" style={{ backgroundColor: COLORS.PRIMARY_BLUE, color: COLORS.WHITE }}>ENTRAR</button>
                        </div>
                        <div className="w-1/2">
                            <button onClick={() => navigate('/cadastro')} className="w-full py-4 text-sm rounded-2xl font-black uppercase tracking-widest transition transform active:scale-95 shadow-xl shadow-green-100" style={{ backgroundColor: COLORS.SUCCESS_GREEN, color: COLORS.WHITE }}>CADASTRAR</button>
                        </div>
                    </div>

                    <div className="relative h-40 flex items-center justify-center rounded-xl overflow-hidden shadow-md">
                        <img src={clienteBg} alt="Ação" className="absolute inset-0 w-full h-full object-cover" />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                    </div>
                </div>
            </div>

            {/* POPUP FLUTUANTE DE INSTALAÇÃO (SURGE APÓS 3s) */}
            {showPopup && (
                <div className="fixed bottom-6 left-4 right-4 z-[100] animate-slide-up">
                    <div className="bg-slate-900 rounded-[2rem] p-5 shadow-2xl border border-slate-700 flex items-center justify-between">
                        <div className="flex items-center space-x-4 min-w-0">
                            <div className="w-12 h-12 bg-blue-600 rounded-2xl flex items-center justify-center shrink-0">
                                <Smartphone className="text-white" size={24} />
                            </div>
                            <div className="min-w-0 text-left">
                                <p className="text-[10px] font-black text-blue-400 uppercase tracking-widest">Experiência Completa</p>
                                <p className="text-xs text-white font-bold truncate pr-2">Instalar App T-SERVI</p>
                            </div>
                        </div>
                        <div className="flex items-center space-x-2">
                            <button onClick={handleInstallAction} className="bg-blue-600 text-white px-4 py-2.5 rounded-xl text-[10px] font-black uppercase tracking-widest active:scale-90 transition-all">Instalar</button>
                            <button onClick={() => setShowPopup(false)} className="p-2 text-slate-500 hover:text-white"><X size={18}/></button>
                        </div>
                    </div>
                </div>
            )}

            {/* GUIA DE INSTALAÇÃO (MODAL) */}
            {showGuide && (
                <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[110] flex items-center justify-center p-6 animate-fade-in">
                    <div className="bg-white rounded-[2.5rem] w-full max-w-sm overflow-hidden relative shadow-2xl">
                        <button onClick={() => setShowGuide(false)} className="absolute top-6 right-6 p-2 bg-gray-100 rounded-full text-gray-500"><X size={20}/></button>
                        <div className="p-8 pt-12 text-center">
                            <div className="w-20 h-20 bg-blue-50 rounded-3xl flex items-center justify-center mx-auto mb-6">
                                <Download size={40} className="text-blue-600" />
                            </div>
                            <h3 className="text-xl font-black text-gray-800 uppercase tracking-tighter mb-4">Como Instalar</h3>
                            <div className="space-y-6 text-left">
                                <div className="flex items-start space-x-4">
                                    <div className="w-6 h-6 bg-blue-600 text-white rounded-full flex items-center justify-center text-[10px] font-black shrink-0">1</div>
                                    <p className="text-xs text-gray-600 font-bold leading-relaxed">Clique nos <span className="text-gray-900">3 pontinhos</span> (Chrome) ou no ícone de <span className="text-gray-900 inline-flex items-center">compartilhar <Share size={12} className="mx-1"/></span> (Safari).</p>
                                </div>
                                <div className="flex items-start space-x-4">
                                    <div className="w-6 h-6 bg-blue-600 text-white rounded-full flex items-center justify-center text-[10px] font-black shrink-0">2</div>
                                    <p className="text-xs text-gray-600 font-bold leading-relaxed">Selecione <span className="text-gray-900 font-black italic">"Instalar Aplicativo"</span> ou <span className="text-gray-900 font-black italic">"Adicionar à Tela de Início"</span>.</p>
                                </div>
                            </div>
                            <button onClick={() => setShowGuide(false)} className="mt-10 w-full py-4 bg-gray-900 text-white font-black uppercase text-xs rounded-2xl tracking-widest">Entendi</button>
                        </div>
                    </div>
                </div>
            )}

            {/* SEÇÃO COMO FUNCIONA */}
            <div className="w-full px-4 mt-10 space-y-8 flex-shrink-0">
                <div className="text-left">
                    <h3 className="text-[10px] font-black text-blue-600 uppercase tracking-[0.2em] mb-4 px-1">Como Funciona</h3>
                    <div className="space-y-4">
                        <div className="bg-white p-5 rounded-[2rem] shadow-sm border border-gray-100 flex items-start space-x-4">
                            <div className="bg-blue-50 p-3 rounded-2xl text-blue-600 shrink-0"><Search size={20}/></div>
                            <div>
                                <p className="text-xs font-black text-gray-800 uppercase tracking-tighter">1. Encontre</p>
                                <p className="text-[10px] text-gray-500 font-bold leading-tight mt-1">Busque por categoria ou localização e veja perfis reais.</p>
                            </div>
                        </div>
                        <div className="bg-white p-5 rounded-[2rem] shadow-sm border border-gray-100 flex items-start space-x-4">
                            <div className="bg-emerald-50 p-3 rounded-2xl text-emerald-600 shrink-0"><MessageSquare size={20}/></div>
                            <div>
                                <p className="text-xs font-black text-gray-800 uppercase tracking-tighter">2. Negocie</p>
                                <p className="text-[10px] text-gray-500 font-bold leading-tight mt-1">Converse via chat seguro, peça fotos e receba orçamentos.</p>
                            </div>
                        </div>
                        <div className="bg-white p-5 rounded-[2rem] shadow-sm border border-gray-100 flex items-start space-x-4">
                            <div className="bg-amber-50 p-3 rounded-2xl text-amber-600 shrink-0"><Star size={20}/></div>
                            <div>
                                <p className="text-xs font-black text-gray-800 uppercase tracking-tighter">3. Avalie e Pague</p>
                                <p className="text-[10px] text-gray-500 font-bold leading-tight mt-1">Pague direto ao profissional via PIX e avalie o serviço.</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* SEÇÃO PARA PROFISSIONAIS */}
                <div className="bg-gray-900 rounded-[2.5rem] p-8 text-white shadow-2xl relative overflow-hidden">
                    <div className="absolute top-0 right-0 p-4 opacity-10"><Users size={80} /></div>
                    <h3 className="text-[10px] font-black text-blue-400 uppercase tracking-[0.2em] mb-2">Para Profissionais</h3>
                    <h4 className="text-lg font-bold leading-tight mb-4">Transforme sua habilidade em um negócio lucrativo.</h4>
                    <ul className="space-y-3 mb-6">
                        <li className="flex items-center text-[10px] font-bold uppercase tracking-widest"><CheckCircle2 size={14} className="mr-2 text-emerald-400"/> Vitrine Digital</li>
                        <li className="flex items-center text-[10px] font-bold uppercase tracking-widest"><CheckCircle2 size={14} className="mr-2 text-emerald-400"/> Gestão de Clientes</li>
                        <li className="flex items-center text-[10px] font-bold uppercase tracking-widest"><CheckCircle2 size={14} className="mr-2 text-emerald-400"/> Sem Taxas Ocultas</li>
                    </ul>
                    <button onClick={() => navigate('/cadastro')} className="w-full py-4 bg-white text-gray-900 rounded-2xl font-black text-[10px] uppercase tracking-[0.2em] active:scale-95 transition-all shadow-xl">Cadastrar como SERVI</button>
                </div>
            </div>

            <PublicFooter />
        </div>
    );
};

export default WelcomeScreen;
